export default __webpack_public_path__ + "f878f481e4e6f0789eed246fc5df2645.png";